export default (initialState = {}) => {
  return () => {
    return {
      name: "",
      ...initialState,
    };
  };
};
